// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Blockchain{
    padding: 20px 0 0;
}
.Blockchain h1 {
    color: var(--primary-blue);
    font-family: Arial, Helvetica, sans-serif;
    /* text-align: center; */
    font-size: 30px;
  }
 .Blockchain p{
    /* font-weight: bolder; */
    line-height: 30px;
    color:var(--primary-grey);
    font-family: Arial, Helvetica, sans-serif;
  }

  .Blockchain-flex-box{
    display: flex;
    gap: 50px;
    padding: 0 20px;
    align-items: center;
  }

  .Blockchain-flex-box img{
    width: 100%;
    max-width: 550px;
  }

  .Blockchain-flex-box p{
    color: var(--primary-grey);
  }
  .Blockchain-flex-box h3{
    color: var(--primary-grey);
  }
  .Blockchain-flex-box ul li{
    color: var(--primary-grey);
  }

  
.button-group {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
}

button.whatsapp {
    background-color: #25D366;
}

button.telegram {
    background-color: #0088CC;
}

button.skype {
    background-color: #00AFF0;
    /* color: #6d72f659; */
}

.Blockchain-h1{
    font-size: 30px;
    color: var(--primary-blue);
}

.Blockchain-card:hover{
  background-color: #6d72f6; 
  transform: translateY(-10px);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
}

@media (max-width:900px) {
    .Blockchain-flex-box{
        flex-direction: column;
    }
}










.mlm-container {
    padding: 40px 20px;
    font-family: Arial, sans-serif;
    text-align: center;
    background-color: #f9f9f9;
  }
  
  .mlm-title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 10px;
    color: var(--primary-blue);
  }
  
  .mlm-subtitle {
    color: #d32f2f;
    margin-bottom: 30px;
    font-size: 16px;
  }
  
  .mlm-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
  }
  
  .mlm-card {
    background-color: #ffffffad;
    border: 1px solid #ffffff80;
    border-radius: 20px;
    padding: 40px 42px 49px 40px;
    transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
  }
  
  .mlm-card:hover {
    transform: translateY(-10px);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  .mlm-icon-container {
    width: 100px;
    height: 100px;
    margin: 0 auto 15px;
    background-color: #f0f0f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  
  .mlm-icon {
    width: 60%;
    height: auto;
  }
  
  .mlm-plan-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    color: var(--primary-blue);
  }
  
  .mlm-description {
    font-size: 14px;
    color: #555;
    text-align: center;
    line-height: 1.6;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/IT_Service/Blockchain/Blockchain.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,wBAAwB;IACxB,eAAe;EACjB;CACD;IACG,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;;AAGF;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;;;;;;;;;;AAWA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;IACnB,4BAA4B;IAC5B,iFAAiF;EACnF;;EAEA;IACE,4BAA4B;IAC5B,4CAA4C;EAC9C;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":[".Blockchain{\n    padding: 20px 0 0;\n}\n.Blockchain h1 {\n    color: var(--primary-blue);\n    font-family: Arial, Helvetica, sans-serif;\n    /* text-align: center; */\n    font-size: 30px;\n  }\n .Blockchain p{\n    /* font-weight: bolder; */\n    line-height: 30px;\n    color:var(--primary-grey);\n    font-family: Arial, Helvetica, sans-serif;\n  }\n\n  .Blockchain-flex-box{\n    display: flex;\n    gap: 50px;\n    padding: 0 20px;\n    align-items: center;\n  }\n\n  .Blockchain-flex-box img{\n    width: 100%;\n    max-width: 550px;\n  }\n\n  .Blockchain-flex-box p{\n    color: var(--primary-grey);\n  }\n  .Blockchain-flex-box h3{\n    color: var(--primary-grey);\n  }\n  .Blockchain-flex-box ul li{\n    color: var(--primary-grey);\n  }\n\n  \n.button-group {\n    display: flex;\n    gap: 10px;\n    margin-top: 20px;\n}\n\nbutton {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #fff;\n}\n\nbutton.whatsapp {\n    background-color: #25D366;\n}\n\nbutton.telegram {\n    background-color: #0088CC;\n}\n\nbutton.skype {\n    background-color: #00AFF0;\n    /* color: #6d72f659; */\n}\n\n.Blockchain-h1{\n    font-size: 30px;\n    color: var(--primary-blue);\n}\n\n.Blockchain-card:hover{\n  background-color: #6d72f6; \n  transform: translateY(-10px);\n  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width:900px) {\n    .Blockchain-flex-box{\n        flex-direction: column;\n    }\n}\n\n\n\n\n\n\n\n\n\n\n.mlm-container {\n    padding: 40px 20px;\n    font-family: Arial, sans-serif;\n    text-align: center;\n    background-color: #f9f9f9;\n  }\n  \n  .mlm-title {\n    font-size: 28px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    color: var(--primary-blue);\n  }\n  \n  .mlm-subtitle {\n    color: #d32f2f;\n    margin-bottom: 30px;\n    font-size: 16px;\n  }\n  \n  .mlm-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 20px;\n  }\n  \n  .mlm-card {\n    background-color: #ffffffad;\n    border: 1px solid #ffffff80;\n    border-radius: 20px;\n    padding: 40px 42px 49px 40px;\n    transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;\n  }\n  \n  .mlm-card:hover {\n    transform: translateY(-10px);\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .mlm-icon-container {\n    width: 100px;\n    height: 100px;\n    margin: 0 auto 15px;\n    background-color: #f0f0f0;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n  }\n  \n  .mlm-icon {\n    width: 60%;\n    height: auto;\n  }\n  \n  .mlm-plan-title {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    color: var(--primary-blue);\n  }\n  \n  .mlm-description {\n    font-size: 14px;\n    color: #555;\n    text-align: center;\n    line-height: 1.6;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
